import React from 'react'
import img from './../../assets/schoolDholpur.png';
const RmsDholpur = () => {
  return (
    <>
    <div style={{ backgroundImage: `url(${img})`,height: '370px',
width: '100%', backgroundRepeat:"no-repeat", backgroundSize:"cover"}} ></div>
    <div className="container-fluid px-5 mb-3" >
      

      <header className=" mt-3 pt-3">
        <h3>RMS Dholpur</h3>

      </header>
         <div className="section pb-3">
                        
                         <div className="content-container mt-3">
                         <p>
                        Rashtriya Military School, Dholpur was the fifth and the youngest of the five Rashtriya Military Schools. Raised on 16 July 1962, the School is the only Rashtriya Military School raised after the Independence.Located on the Dholpur - Bari Highway, the School is housed in a regal palace donated by the erstwhile Maharaja of Dholpur, Udaybhan Singh.
                        The School Campus is spread over an area of more than 1500 acres of the Royal Estate. Though being the youngest, the School has come to establish itself as one of the premier residential public schools of the country, with its alumni spread all across the globe.

                    </p>
         
                         </div>
                     </div>
                     </div>
                     </>
  )
}

export default RmsDholpur
